import {
  CreateFeedbackPayload,
  FEEDBACK_TRIGGERS,
  FeedbackTrigger,
} from '../../data/models/Feedback/Feedback';

export const MIN_ANSWERS = 2;
export const MAX_ANSWERS = 4;
export const MAX_TITLE_LENGTH = 200;
export const MAX_QUESTION_LENGTH = 1000;
// Stricter than the backend (200) so answers fit the phone card
export const MAX_ANSWER_LENGTH = 140;
export const DEFAULT_TRIGGER: FeedbackTrigger = 3;

export interface FeedbackForm {
  title: string;
  question: string;
  answers: string[];
  trigger: FeedbackTrigger;
}

export const EMPTY_FORM: FeedbackForm = {
  title: '',
  question: '',
  answers: ['', ''],
  trigger: DEFAULT_TRIGGER,
};

export const isFeedbackTrigger = (value: unknown): value is FeedbackTrigger =>
  FEEDBACK_TRIGGERS.includes(value as FeedbackTrigger);

export const hasDuplicateAnswers = (answers: string[]) => {
  const values = answers
    .map(answer => answer.trim().toLowerCase())
    .filter(Boolean);
  return new Set(values).size !== values.length;
};

export const isFormValid = (form: FeedbackForm) => {
  const title = form.title.trim();
  const question = form.question.trim();
  return (
    title.length > 0 &&
    title.length <= MAX_TITLE_LENGTH &&
    question.length > 0 &&
    question.length <= MAX_QUESTION_LENGTH &&
    form.answers.length >= MIN_ANSWERS &&
    form.answers.length <= MAX_ANSWERS &&
    form.answers.every(answer => {
      const value = answer.trim();
      return value.length > 0 && value.length <= MAX_ANSWER_LENGTH;
    }) &&
    !hasDuplicateAnswers(form.answers) &&
    isFeedbackTrigger(form.trigger)
  );
};

export const payloadFromForm = (form: FeedbackForm): CreateFeedbackPayload => ({
  title: form.title.trim(),
  question: form.question.trim(),
  numberOfFinishedLessonTrigger: form.trigger,
  answers: form.answers.map(answer => answer.trim()),
});
